import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Accordion } from "@/components/ui/accordion";
import { GeneralCamping } from "@/components/fishing-regulations/sections/GeneralCamping";
import { QuietHours } from "@/components/fishing-regulations/sections/QuietHours";
import { CampfireSafety } from "@/components/fishing-regulations/sections/CampfireSafety";
import { TrashCleanliness } from "@/components/fishing-regulations/sections/TrashCleanliness";
import { WildlifeGuidelines } from "@/components/fishing-regulations/sections/WildlifeGuidelines";
import { WildlifePrecautions } from "@/components/fishing-regulations/sections/WildlifePrecautions";
import { Firearms } from "@/components/fishing-regulations/sections/Firearms";

export type CampingRegSection =
  | "general-camping"
  | "quiet-hours"
  | "campfire-safety"
  | "trash-cleanliness"
  | "wildlife-environment"
  | "wildlife-precautions"
  | "firearms";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultSection?: CampingRegSection;
}

export const CampingRegulationsDialog: React.FC<Props> = ({ open, onOpenChange, defaultSection }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-tribal-secondary">Camping Rules & Regulations</DialogTitle>
        </DialogHeader>
        <Accordion
          type="multiple"
          defaultValue={defaultSection ? [defaultSection] : ["general-camping"]}
          className="w-full space-y-3"
        >
          <GeneralCamping />
          <QuietHours />
          <CampfireSafety />
          <TrashCleanliness />
          <WildlifeGuidelines />
          <WildlifePrecautions />
          <Firearms />
        </Accordion>
      </DialogContent>
    </Dialog>
  );
};
